;(function () {
  angular
    .module('contrast.cve')
    .controller('csCveInfoModalCtrl', [
      'csCveInfoService',
      '$uibModalInstance',
      csCveInfoModalCtrl
    ])

  function csCveInfoModalCtrl(csCveInfoService, $uibModalInstance) {
    var vm = this

    activate()

    vm.activate = activate
    vm.cancel = cancel

    function activate() {
      vm.vuln = csCveInfoService.get()
    }

    function cancel() {
      $uibModalInstance.close()
    }
  }
})()
